var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "py-6" },
    [
      _c(
        "v-btn",
        { staticClass: "btn btn-sm mb-2" },
        [
          _c(
            "router-link",
            {
              attrs: {
                to: "/pages/account/5d06629f4e20444ea87e12364c4fa9ef/all-clients",
              },
            },
            [_vm._v("Back")]
          ),
        ],
        1
      ),
      _vm.showAlert
        ? _c("Alert", {
            attrs: { text: _vm.alertMessage, type: _vm.alertType },
          })
        : _vm._e(),
      _c(
        "v-card",
        { attrs: { outlined: "" } },
        [
          _vm.loading
            ? _c(
                "div",
                { staticClass: "my-5 justify-center d-flex" },
                [
                  _c("v-progress-circular", {
                    staticClass: "px-8",
                    attrs: { indeterminate: "" },
                  }),
                  _c("span", [_vm._v("Loading client..")]),
                ],
                1
              )
            : _vm._e(),
          _c("transition", { attrs: { name: "stf-fade" } }, [
            !_vm.loading
              ? _c(
                  "div",
                  { staticClass: "client-info" },
                  [
                    _c(
                      "v-toolbar-title",
                      { staticClass: "mx-4 my-4 d-flex align-center" },
                      [
                        _c(
                          "b",
                          [
                            _c("EditableField", {
                              attrs: {
                                value: _vm.clientPageData.name,
                                keyPath: "clientPageData.name",
                                hideLabel: "",
                                editing: _vm.editMode,
                              },
                              on: { save: _vm.updateApiData },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "value",
                                    fn: function () {
                                      return [
                                        _c("h2", [
                                          _vm._v(
                                            _vm._s(_vm.clientPageData.name)
                                          ),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3845338213
                              ),
                            }),
                          ],
                          1
                        ),
                        _c("v-spacer"),
                        _vm.editMode
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "btn-sm float-sm-right mt-2 mx-2",
                                attrs: { small: "" },
                                on: { click: _vm.cancelEdit },
                              },
                              [_vm._v(" Cancel ")]
                            )
                          : _vm._e(),
                        _c(
                          "v-btn",
                          {
                            staticClass: "float-sm-right mt-2 mx-2 mr-6",
                            attrs: { icon: "", small: "" },
                            on: { click: _vm.toggleEdit },
                          },
                          [
                            _c("v-icon", [
                              _vm._v(
                                _vm._s(
                                  _vm.editMode
                                    ? "mdi-content-save"
                                    : "mdi-account-edit"
                                )
                              ),
                            ]),
                            _vm._v(
                              " " + _vm._s(_vm.editMode ? "Save" : "Edit") + " "
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ml-2",
                            attrs: { icon: "", color: "error" },
                            on: {
                              click: function ($event) {
                                _vm.showDeleteDialog = true
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-delete")])],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-dialog",
                      {
                        attrs: { "max-width": "400" },
                        model: {
                          value: _vm.showDeleteDialog,
                          callback: function ($$v) {
                            _vm.showDeleteDialog = $$v
                          },
                          expression: "showDeleteDialog",
                        },
                      },
                      [
                        _c(
                          "v-card",
                          [
                            _c("v-card-title", { staticClass: "headline" }, [
                              _vm._v("Delete Client?"),
                            ]),
                            _c("v-card-text", [
                              _vm._v(
                                " Are you sure you want to delete this client? This action cannot be undone. "
                              ),
                            ]),
                            _c(
                              "v-card-actions",
                              [
                                _c("v-spacer"),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      text: "",
                                      color: "grey",
                                      disabled: _vm.deletingClient,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.showDeleteDialog = false
                                      },
                                    },
                                  },
                                  [_vm._v(" Cancel ")]
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      text: "",
                                      color: "red",
                                      loading: _vm.deletingClient,
                                      disabled: _vm.deletingClient,
                                    },
                                    on: { click: _vm.deleteClient },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.deletingClient
                                            ? "Deleting..."
                                            : "Delete"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("v-divider"),
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "6" } },
                              [
                                _c(
                                  "v-list-item",
                                  [
                                    _c("EditableField", {
                                      attrs: {
                                        value: _vm.clientPageData.email,
                                        keyPath: "clientPageData.email",
                                        label: "Email",
                                        editing: _vm.editMode,
                                      },
                                      on: { save: _vm.updateApiData },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "label",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "v-list-item-title",
                                                  { staticClass: "mb-0" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-weight-bold",
                                                      },
                                                      [_vm._v("Email")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        2756948371
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item",
                                  [
                                    _c("EditableField", {
                                      attrs: {
                                        value: _vm.clientPageData.phone,
                                        keyPath: "clientPageData.phone",
                                        label: "Phone",
                                        editing: _vm.editMode,
                                      },
                                      on: { save: _vm.updateApiData },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "label",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "v-list-item-title",
                                                  { staticClass: "mb-0" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-weight-bold",
                                                      },
                                                      [_vm._v("Phone")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3301776003
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "6" } },
                              [
                                _c(
                                  "v-list-item",
                                  [
                                    _c("EditableField", {
                                      attrs: {
                                        value: _vm.clientPageData.address,
                                        keyPath: "clientPageData.address",
                                        label: "Address",
                                        editing: _vm.editMode,
                                      },
                                      on: { save: _vm.updateApiData },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item",
                                  [
                                    _c("EditableField", {
                                      attrs: {
                                        value: _vm.clientPageData.status,
                                        keyPath: "clientPageData.status",
                                        label: "Status",
                                        editing: _vm.editMode,
                                      },
                                      on: { save: _vm.updateApiData },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("ClientRecentProjects", {
                              attrs: {
                                projects: _vm.clientPageData.recent_projects,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _vm.creatingContact
                              ? _c("NewClientContact", {
                                  attrs: { clientId: _vm.clientPageData.id },
                                  on: {
                                    contactCreated: function ($event) {
                                      _vm.apiSetClientData()
                                      _vm.creatingContact = false
                                    },
                                    cancel: function ($event) {
                                      _vm.creatingContact = false
                                    },
                                  },
                                })
                              : _vm._e(),
                            _c("ClientContacts", {
                              attrs: {
                                creating: _vm.creatingContact,
                                contacts: _vm.clientPageData.contacts,
                              },
                              on: {
                                save: _vm.updateApiData,
                                createReq: function ($event) {
                                  _vm.creatingContact = true
                                },
                              },
                            }),
                            _vm.creatingDomain
                              ? _c("NewClientDomain", {
                                  attrs: { clientId: _vm.clientPageData.id },
                                  on: {
                                    domainCreated: function ($event) {
                                      _vm.apiSetClientData()
                                      _vm.creatingDomain = false
                                    },
                                    cancel: function ($event) {
                                      _vm.creatingDomain = false
                                    },
                                  },
                                })
                              : _vm._e(),
                            _c("ClientDomains", {
                              attrs: {
                                creating: _vm.creatingDomain,
                                domains: _vm.clientPageData.domains,
                              },
                              on: {
                                save: _vm.updateApiData,
                                createReq: function ($event) {
                                  _vm.creatingDomain = true
                                },
                              },
                            }),
                            _vm.creatingService
                              ? _c("NewClientService", {
                                  attrs: { clientId: _vm.clientPageData.id },
                                  on: {
                                    serviceCreated: function ($event) {
                                      _vm.apiSetClientData()
                                      _vm.creatingService = false
                                    },
                                    cancel: function ($event) {
                                      _vm.creatingService = false
                                    },
                                  },
                                })
                              : _vm._e(),
                            _c("ClientServices", {
                              attrs: {
                                creating: _vm.creatingService,
                                services: _vm.clientPageData.services,
                              },
                              on: {
                                save: _vm.updateApiData,
                                createReq: function ($event) {
                                  _vm.creatingService = true
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }